"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScreen = void 0;
const react_1 = require("react");
const constants_1 = require("../../theme/constants");
const useScreen = () => {
    const isTabletOrSmaller = (0, react_1.useCallback)(() => window.outerWidth <= parseInt(constants_1.sizes.tablet), []);
    return (0, react_1.useMemo)(() => ({
        isTabletOrSmaller,
    }), [
        isTabletOrSmaller,
    ]);
};
exports.useScreen = useScreen;
//# sourceMappingURL=useScreen.js.map